import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CoreCommonModule } from '@core/common.module';
import { IconsModule } from 'app/components/icons';

import { EdgePanelComponent } from './edge-panel.component';

@NgModule({
  declarations: [EdgePanelComponent],
  imports: [
    CoreCommonModule,
    TranslateModule,
    // Los nodos de headquarters traen iconos de lucide; el resto del panel
    // sigue con el iconfont de feather
    IconsModule,
  ],
  exports: [EdgePanelComponent]
})
export class EdgePanelModule {}
